var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgArrowButtonLeft = function SvgArrowButtonLeft(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19.5,
    fill: "white",
    stroke: "#595959"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.3536 20.3536C28.5488 20.1583 28.5488 19.8417 28.3536 19.6464L25.1716 16.4645C24.9763 16.2692 24.6597 16.2692 24.4645 16.4645C24.2692 16.6597 24.2692 16.9763 24.4645 17.1716L27.2929 20L24.4645 22.8284C24.2692 23.0237 24.2692 23.3403 24.4645 23.5355C24.6597 23.7308 24.9763 23.7308 25.1716 23.5355L28.3536 20.3536ZM12 20.5H28V19.5H12V20.5Z",
    fill: "#595959"
  })));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgArrowButtonLeft);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMjAiIGN5PSIyMCIgcj0iMTkuNSIgZmlsbD0id2hpdGUiIHN0cm9rZT0iIzU5NTk1OSIvPgo8cGF0aCBkPSJNMjguMzUzNiAyMC4zNTM2QzI4LjU0ODggMjAuMTU4MyAyOC41NDg4IDE5Ljg0MTcgMjguMzUzNiAxOS42NDY0TDI1LjE3MTYgMTYuNDY0NUMyNC45NzYzIDE2LjI2OTIgMjQuNjU5NyAxNi4yNjkyIDI0LjQ2NDUgMTYuNDY0NUMyNC4yNjkyIDE2LjY1OTcgMjQuMjY5MiAxNi45NzYzIDI0LjQ2NDUgMTcuMTcxNkwyNy4yOTI5IDIwTDI0LjQ2NDUgMjIuODI4NEMyNC4yNjkyIDIzLjAyMzcgMjQuMjY5MiAyMy4zNDAzIDI0LjQ2NDUgMjMuNTM1NUMyNC42NTk3IDIzLjczMDggMjQuOTc2MyAyMy43MzA4IDI1LjE3MTYgMjMuNTM1NUwyOC4zNTM2IDIwLjM1MzZaTTEyIDIwLjVIMjhWMTkuNUgxMlYyMC41WiIgZmlsbD0iIzU5NTk1OSIvPgo8L3N2Zz4K";